import { render, staticRenderFns } from "./rack.vue?vue&type=template&id=0ecdb474&"
import script from "./rack.vue?vue&type=script&lang=js&"
export * from "./rack.vue?vue&type=script&lang=js&"
import style0 from "./rack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports